import TaskListWrapper from "../TaskListWrapper";

export default function CompletedList({ list, setList }) {
  return <TaskListWrapper setList={setList} data={list} />;
}
